export const COMPONENT_TO_LUCIDE = {
  'home-icon': 'home',
  location: 'map-pin',
  'user-roles-icon': 'user-cog',
  'user-icon': 'users',
  news: 'newspaper',
  'message-icon': 'message-square',
  'payments-icon': 'dollar-sign',
  'form-icon': 'clipboard-list',
  offer: 'store',
  reward: 'gift',
  'directory-icon': 'book-open',
  'community-icon': 'users-round',
  'contact-us-icon': 'phone',
  'parcels-icon': 'package',
  access: 'shield',
  clientinformation: 'bell',
  'spaces-reservation-icon': 'calendar-days',
  'alarm-icon': 'alarm-clock',
  'device-icon': 'smartphone',
  'business-invitations-icon': 'briefcase',
  'calendar-icon': 'calendar',
  'providers-icon': 'truck',
  'officials-icon': 'badge-check',
  'census-icon': 'clipboard-check',
  'brigade-members-icon': 'hard-hat',
  'waste-sorting-icon': 'recycle'
}

export const ICON_SIZE = {
  sm: 14,
  md: 20,
  lg: 22
}

export function toPascalCase(kebab) {
  if (!kebab) return ''
  return String(kebab)
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')
}

export function resolveLucideName(componentKey) {
  if (!componentKey) return 'circle'
  return COMPONENT_TO_LUCIDE[componentKey] || 'circle'
}



// WEBPACK FOOTER //
// ./src/components/layout/iconMap.js